<p-dialog
	header="Row Comments"
	[visible]="visible"
	[modal]="true"
	[closable]="!isSaving"
	[closeOnEscape]="!isSaving"
	[dismissableMask]="!isSaving"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '680px', maxWidth: '95vw' }"
	[breakpoints]="{
      '960px': '75vw',
      '640px': '95vw'
   }"
	(visibleChange)="onDialogVisibleChange($event)"
>
	<div class="row-comments-modal">
		<section
			class="comment-composer"
			aria-labelledby="row-comment-composer-heading"
		>
			<div class="comment-section-heading">
				<div>
					<h3 id="row-comment-composer-heading">Add a new comment</h3>
					<p>
						Comments are permanent and cannot be edited or removed after
						they are added.
					</p>
				</div>
			</div>

			<label
				class="comment-label"
				for="report-row-comment-draft"
			>
				Comment
			</label>

			<textarea
				id="report-row-comment-draft"
				pInputTextarea
				rows="4"
				[(ngModel)]="commentDraft"
				[disabled]="isSaving"
				placeholder="Type your comment here..."
				class="comment-textarea"
			></textarea>

			<div
				*ngIf="saveError"
				class="comment-error"
				role="alert"
			>
				<i class="pi pi-exclamation-circle"></i>
				<span>{{ saveError }}</span>
			</div>

			<div class="comment-composer-actions">
				<button
					pButton
					type="button"
					label="Close"
					class="p-button-text"
					[disabled]="isSaving"
					(click)="closeModal()"
				></button>

				<button
					pButton
					type="button"
					[label]="isSaving ? 'Adding...' : 'Add Comment'"
					icon="pi pi-plus"
					[loading]="isSaving"
					[disabled]="!canAddComment"
					(click)="addComment()"
				></button>
			</div>
		</section>

		<section
			class="comment-history"
			aria-labelledby="row-comment-history-heading"
		>
			<div class="comment-history-heading">
				<div>
					<h3 id="row-comment-history-heading">Comment history</h3>
					<p>Newest comments appear first.</p>
				</div>

				<span
					*ngIf="comments.length > 0"
					class="comment-count"
				>
               {{ comments.length }}
					{{ comments.length === 1 ? 'comment' : 'comments' }}
            </span>
			</div>

			<div
				*ngIf="isHistoryLoading"
				class="comment-state"
				aria-live="polite"
			>
				<i class="pi pi-spin pi-spinner"></i>
				<span>Loading comments...</span>
			</div>

			<div
				*ngIf="!isHistoryLoading && historyError"
				class="comment-state comment-state-error"
				role="alert"
			>
				<i class="pi pi-exclamation-circle"></i>

				<div>
					<div>{{ historyError }}</div>

					<button
						pButton
						type="button"
						label="Try Again"
						class="p-button-text p-button-sm"
						(click)="retryHistory()"
					></button>
				</div>
			</div>

			<div
				*ngIf="
               !isHistoryLoading &&
               !historyError &&
               comments.length === 0
            "
				class="comment-state comment-empty-state"
			>
				<i class="pi pi-comments"></i>

				<div>
					<strong>No comments yet</strong>
					<span>Add the first comment for this row.</span>
				</div>
			</div>

			<div
				*ngIf="!isHistoryLoading && comments.length > 0"
				class="comment-history-list"
			>
				<article
					*ngFor="
                  let item of comments;
                  trackBy: trackCommentByEventId
               "
					class="comment-history-item"
				>
					<div class="comment-avatar" aria-hidden="true">
						{{ getActorInitials(item) }}
					</div>

					<div class="comment-content">
						<div class="comment-meta">
							<div class="comment-author">
								<span>{{ getCommentActionLabel(item) }}</span>
								<strong>{{ item.actorDisplayName }}</strong>

								<span
									*ngIf="
                              item.actorEmail &&
                              item.actorEmail !== item.actorDisplayName
                           "
									class="comment-email"
								>
                           {{ item.actorEmail }}
                        </span>
							</div>

							<time
								[attr.datetime]="item.createdAtIso"
								[attr.title]="item.createdAtIso"
							>
								{{ formatCommentDate(item.createdAtIso) }}
							</time>
						</div>

						<p class="comment-text">
							{{ item.commentText }}
						</p>
					</div>
				</article>
			</div>

			<div
				*ngIf="hasMore && !isHistoryLoading"
				class="load-older-actions"
			>
				<button
					pButton
					type="button"
					[label]="
                  isLoadingOlder
                     ? 'Loading...'
                     : 'Load Older Comments'
               "
					class="p-button-outlined p-button-sm"
					[loading]="isLoadingOlder"
					[disabled]="isLoadingOlder"
					(click)="loadOlderComments()"
				></button>
			</div>
		</section>
	</div>
</p-dialog>
